import { Deserializable } from '../_common/deserializable';

export class DnCharge implements Deserializable{
    shortCode: string;
    keyword: string;
    affiliate: string;
    operator: string;
    spiderAccount: string;
    client: string;
    share: string;
    subscriber: number;
    expectedDn: number;
    dn: number;
    dnDiff: number;
    dnSuccess: number;
    amount: string;
    successDnRate: string;
    successExpectedDnRate: string;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }
}
